import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RaceSliderHrList } from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/RaceBoxHr.style';
import { CardHeader } from 'src/domains/sportsbook/webview/components/racesSlider/shared/cardHeader/CardHeader';
import { CardBody } from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/cardBody/CardBody';
import { CardFooter } from 'src/domains/sportsbook/webview/components/racesSlider/shared/cardFooter/CardFooter';

export interface RaceSliderHrPropsType {
    race: EventModel;
    market: MarketModel;
    sortSelections: (list: Array<SelectionModel>) => Array<SelectionModel>;
}

export const RaceSliderHr = observer('RaceSliderHr', (props: RaceSliderHrPropsType) => {
    const { race, market, sortSelections } = props;

    const routingData: RacecardRaceRouteType = {
        collection: race.competition2.toOldId(),
        name: 'racecard',
        selected: race.id2.toOldId(),
        sport: race.sport,
    };

    return (
        <RaceSliderHrList key='race-box-selections'>
            <CardHeader
                race={race}
                routingData={routingData}
            />
            <CardBody
                race={race}
                market={market}
                sortSelections={sortSelections}
            />
            <CardFooter routingData={routingData} />
        </RaceSliderHrList>
    );
});
